import { render, staticRenderFns } from "./SidebarProductSizeStockBlock.vue?vue&type=template&id=47bf4dc3&scoped=true"
import script from "./SidebarProductSizeStockBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarProductSizeStockBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarProductSizeStockBlock.vue?vue&type=style&index=0&id=47bf4dc3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bf4dc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47bf4dc3')) {
      api.createRecord('47bf4dc3', component.options)
    } else {
      api.reload('47bf4dc3', component.options)
    }
    module.hot.accept("./SidebarProductSizeStockBlock.vue?vue&type=template&id=47bf4dc3&scoped=true", function () {
      api.rerender('47bf4dc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarProductSizeStockBlock.vue"
export default component.exports